var cell_phone = {};
module['exports'] = cell_phone;
cell_phone.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_AT/cell_phone/index.js
 ** module id = 364
 ** module chunks = 0
 **/